import bytesToSize from "./bytesToSize.js";

// STORAGE เป็นโควตา (CAPACITY) ไม่ใช่ธงเปิด/ปิด — null แปลว่าไม่จำกัด (PREMIUM)
// ห้ามใช้ entitlementFlag(STORAGE) ซึ่งทำ Boolean(value) แล้ว null กลายเป็น false
// ทำให้แพ็กที่ใหญ่ที่สุดอัปโหลดไม่ได้
//
// รับค่าจาก entitlementLimit(FEATURE.STORAGE) (stores/branch.js) ซึ่งจัดการเส้นทางถอย
// ตอนไม่มีข้อมูลจาก API ให้แล้ว: มี subscription เดิม -> null, ไม่มี -> 0
// undefined (ข้อมูลเพี้ยน) ไม่นับเป็นไม่จำกัด
export const hasStorageEntitlement = (limit) =>
  limit === null || (typeof limit === "number" && limit > 0);

// โควตาสำหรับแสดงผล — bytesToSize(null) ได้ "0 Bytes" ซึ่งผิดตรงข้ามกับความจริงของ PREMIUM
export const describeStorageQuota = (limit) =>
  limit === null ? "ไม่จำกัด" : bytesToSize(limit);

// วันหมดอายุของพื้นที่ที่แสดงในหน้าจัดการไฟล์ — ใช้ของแพ็กปัจจุบันก่อน (ตรงกับหน้าแพ็ก)
// สาขาที่ไม่มีแพ็กเสียเงินแต่มีแพ็กเดิมใช้วันของแพ็กเดิม · FREE ล้วนไม่มีวันหมด (null)
export const storageEndDate = ({ subscriptionEndDate, legacy }) =>
  subscriptionEndDate || (legacy && legacy.endDate) || null;

// เปอร์เซ็นต์ที่ใช้ไปของแถบพื้นที่ — ไม่จำกัด (null) หรือไม่มีโควตาให้ 0 ไม่ใช่หารด้วย 0
export const storageUsagePercent = (used, limit) => {
  if (typeof limit !== "number" || limit <= 0) return 0;
  const usedBytes = Number(used) || 0;
  return Math.min(100, Math.round((usedBytes / limit) * 100));
};

// พื้นที่ที่เหลือ (bytes) — null แปลว่าไม่ต้องแสดงตัวเลข (ไม่จำกัด หรือไม่รู้โควตา)
export const storageLeft = (limit, used) => {
  if (typeof limit !== "number") return null;
  return Math.max(0, limit - (Number(used) || 0));
};
